/**
 * Web Style Import
 *
 */

import './dnb-toggle-button.scss'
